import { FormStore, FormValidator } from '@estee/elc-form';
import { computed } from 'mobx';

export interface INotifyMeForm {
    userEmail: string;
}

export interface INotifyMeConfig {
    notifyMeFormValidator: FormValidator;
}

export class NotifyMeForm extends FormStore<INotifyMeForm> {
    constructor(configStore: INotifyMeConfig) {
        super({
            initialValues: {
                userEmail: ''
            },
            formValidator: configStore.notifyMeFormValidator
        });
    }

    @computed
    get userEmail() {
        return this.values.userEmail;
    }
}
